var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { IconButton, Tooltip } from '@material-ui/core';
import { ImportExport, Sort } from '@material-ui/icons';
import React, { useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { TopLabeledTextField } from '../..';
import { isIOption } from '../../types/commonTypes';
import { ColumnHeader, ColumnStyle, ItemList, SortWrapper, } from '../DuoColumnSelector.Styles';
import { Item } from './Item';
export var Column = function (_a) {
    var columnName = _a.columnName, columnID = _a.columnID, items = _a.items, onItemClick = _a.onItemClick, onReverse = _a.onReverse, onSort = _a.onSort;
    var _b = useState(''), filter = _b[0], setFilter = _b[1];
    return (React.createElement(ColumnStyle, null,
        React.createElement(ColumnHeader, null,
            React.createElement("div", null, columnName),
            React.createElement(SortWrapper, null,
                React.createElement(Tooltip, { title: 'Sort' },
                    React.createElement(IconButton, { size: 'small', component: 'span', onClick: function () { return items.length > 0 && onSort(); } },
                        React.createElement(Sort, { fontSize: 'small' }))),
                React.createElement(Tooltip, { title: 'Reorder' },
                    React.createElement(IconButton, { size: 'small', component: 'span', onClick: function () { return items.length > 0 && onReverse(); } },
                        React.createElement(ImportExport, { fontSize: 'small' }))))),
        React.createElement(TopLabeledTextField, { name: 'columnName', label: '', value: filter, onChange: function (e) { return setFilter(e.target.value); }, placeholder: columnName }),
        React.createElement(Droppable, { droppableId: columnID }, function (provided) { return (React.createElement(ItemList, __assign({ innerRef: provided.innerRef }, provided.droppableProps), items === null || items === void 0 ? void 0 :
            items.filter(function (i) {
                var _a, _b;
                if (isIOption(i)) {
                    return (((_a = i.label.toLowerCase()) === null || _a === void 0 ? void 0 : _a.indexOf(filter.toLowerCase())) !== -1);
                }
                else {
                    return ((_b = i.toLowerCase()) === null || _b === void 0 ? void 0 : _b.indexOf(filter.toLowerCase())) !== -1;
                }
            }).map(function (item, index) { return (React.createElement(Item, { key: index, value: item, id: index, onItemClick: function (draggableId, index) {
                    return onItemClick(columnID, draggableId, index);
                } })); }),
            provided.placeholder)); })));
};
Column.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=Column.js.map